import { HttpClient, HttpResponse } from '@angular/common/http';
import type { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { CbreHttpConfig, CbreHttpConfigToken } from '../cbre-http.config';

@Injectable()
export class HttpMethods {
  protected baseUrl: string = 'cepapi/api';
  constructor(
    private http: HttpClient,
    @Inject(CbreHttpConfigToken) options?: CbreHttpConfig
  ) {}

  private constructBaseUrl(uri: string): string {
    let baseUrlCopy = this.baseUrl;

    // Remove HTTP method prefix using a regular expression
    uri = uri.replace(/^(post:|get:)/, '');

    const serviceBaseUrl = ['reports', 'privacycontrol', 'search', 'aiplatform'];

    if (serviceBaseUrl.some(base => uri.startsWith(base))) {
      return baseUrlCopy.slice(0, -4) + this.normalizeUri(uri);
    }

    if (uri.startsWith('/download/miq/')) {
      baseUrlCopy = baseUrlCopy.replace('cepapi/api', 'cepapi');
      uri = uri.replace(/^\/download\/miq\//, '/reports/marketiq/');
      return baseUrlCopy + this.normalizeUri(uri);
    }

    return baseUrlCopy + this.normalizeUri(uri);
  }

  normalizeUri(uri: string) {
    return uri.startsWith('/') ? uri : `/${uri}`;
  }
  public httpGet(uri: string, params?: HttpParams): Observable<any> {
    const baseUrl = this.constructBaseUrl(uri);

    return this.http.get(baseUrl, { params: params || null }).pipe(take(1));
  }

  public httpGetBlob(uri: string, params?: HttpParams): Observable<HttpResponse<Blob>> {
    const baseUrl = this.constructBaseUrl(uri);

    return this.http
      .get(baseUrl, { params: params || null, responseType: 'blob', observe: 'response' })
      .pipe(take(1));
  }

  public httpPost<T>(uri: string, data: T, options?: any): Observable<any> {
    const baseUrl = this.constructBaseUrl(uri);
    return this.http.post(baseUrl, data, options).pipe(take(1));
  }

  public httpDelete<T>(uri: string, options?: T): Observable<any> {
    const baseUrl = this.constructBaseUrl(uri);
    return this.http.delete(baseUrl, options).pipe(take(1));
  }

  public httpPut<T>(uri: string, data?: T, options?: any): Observable<any> {
    const baseUrl = this.constructBaseUrl(uri);
    return this.http.put(baseUrl, data, options).pipe(take(1));
  }
}
